import React, { useState, useEffect, useContext } from 'react';
import AdminContext from '../../StateContext/Application';
import { True32 } from '../../../../public/LoginImages/importimages'
import { apiurl } from '../../../../path';
const BillApprovals = () => {
    const context = useContext(AdminContext);
    const { GetBills, ApproveBills } = context; // Ensure ApproveBills is defined in your context
    const [bills, setBills] = useState([]);
    const [selectedBills, setSelectedBills] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const billsPerPage = 4; // Show 4 bills per page
    const [loading, setLoading] = useState(false);
    const [filter, setFilter] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredBills, setFilteredBills] = useState([]);

    // Filter logic
    // const filteredBills = filter ? bills.filter((bill) => bill.TypeOfAmount === filter) : bills;
    const getbills = async () => {
        let data = await GetBills();
        console.log("data",data);
        
        setBills(data);
        setFilteredBills(data);
    };

    useEffect(() => {
        getbills();
    }, []);

    // Pagination logic
    const totalPages = Math.ceil(filteredBills ? filteredBills.length / billsPerPage : bills.length / billsPerPage);

    const indexOfLastBill = currentPage * billsPerPage;
    const indexOfFirstBill = indexOfLastBill - billsPerPage;
    const currentBills = filteredBills ? filteredBills.slice(indexOfFirstBill, indexOfLastBill) : bills.slice(indexOfFirstBill, indexOfLastBill);

    // Handle individual checkbox selection
    const handleCheckboxChange = (id) => {
        setSelectedBills((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((billId) => billId !== id) // Remove if already selected
                : [...prevSelected, id] // Add if not selected
        );
    };

    // Handle "Select All" checkbox
    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setSelectedBills(filteredBills.map((bill) => bill.BillNumber));
        } else {
            setSelectedBills([]);
        }
    };
    // const handleSelectAll = (event) => {
    //     if (event.target.checked) {
    //         if (filteredBills.length === 0) {
    //             setSelectedBills(bills.map((bill) => bill.UniqueID)); // Select all
    //             return;
    //         }
    //         setSelectedBills(currentBills.map((bill) => bill.UniqueID));// Select all
    //     } else {
    //         setSelectedBills([]); // Deselect all
    //     }
    // };

    // Send selected bills to backend for approval
    const approveSelected = async () => {
        if (selectedBills.length === 0) {
            alert('No bills selected for approval!');
            return;
        }
        console.log(selectedBills);
        setLoading(true); // Start loader
        try {
            let response = await ApproveBills(selectedBills); // Call backend function
            if (response.message) {
                alert(response.message);
                getbills(); // Refresh the list after approval
            }
            if (response.error) {
                alert(response.error)
                getbills(); // Refresh the list after approval
            }
        } catch (error) {
            console.error('Error approving bills:', error);
            alert('An error occurred while approving bills.');
        }
        setLoading(false); // Stop loader
    };

    useEffect(() => {
        const lowerSearchTerm = searchTerm.toLowerCase();
        const filtered = bills.filter(bill =>
            Object.values(bill).some((bill) =>
                (bill || '').toString().toLowerCase().includes(lowerSearchTerm)
            )
        );
        setFilteredBills(filtered);
        setCurrentPage(1); // Reset to page 1 on search
    }, [searchTerm, bills]);
    return (
        <div style={{ backgroundColor: '#f4f7fe', height: "88vh" }}>
            <div>
                <h4 style={{ margin: '10px' }}>Bill Approvals</h4>
                {/* Separate "Select All Files" checkbox */}

                {bills.length === 0 && <h4 style={{ backgroundColor: '#324e77', padding: '10px', color: 'white', textAlign: 'center', margin: '10px' }}>No Bills For Approvals</h4>}
            </div>

            <div style={{ display: 'grid', justifyContent: 'center', padding: '0px 20px', backgroundColor: '#f4f7fe' }}>

                {bills.length > 0 &&
                    <>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0px 3rem' }}>
                            <th style={{ display: 'flex', alignItems: 'center', paddingLeft: '10px' }}>
                                <input
                                    type="checkbox"
                                    onChange={handleSelectAll}
                                    checked={selectedBills.length === filteredBills.length && filteredBills.length > 0}
                                    style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                />
                                <label >Select All Files</label>
                            </th>

                            {/* Filter Dropdown */}
                            {/* <div style={{ margin: '10px' }}>
                        <label style={{ fontWeight: 'bold', marginRight: '10px' }}>Filter by Amount Type:</label>
                        <select onChange={(e) => setFilter(e.target.value)} value={filter}>
                            <option value=''>All</option>
                            <option value='Total Amount Payable'>Total Amount Payable</option>
                            <option value='GST'>GST</option>
                            <option value='TDS'>TDS</option>
                        </select>
                    </div> */}
                            <div>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    value={searchTerm}
                                    style={{ width: "85%", padding: "10px", borderRadius: "5px", border: "1px solid #ccc", marginBottom: "10px", backgroundColor: 'aliceblue' }}
                                />
                            </div>
                        </div>
                        <div style={{ display: "grid", justifyContent: "center", boxShadow: "0px 0px 3px", borderRadius: "20px", width: "78vw", }}>
                            <div style={{ overflowX: "auto", width: "78vw", borderRadius: "20px", }}>
                                <table style={{ backgroundColor: "white", width: "100%", borderRadius: "20px", overflow: "hidden", borderCollapse: "collapse", }}>
                                    <thead style={{ borderTop: "none" }}>
                                        {currentBills.length > 0 && (
                                            <tr style={{ background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: "black", border: "none", borderRadius: "10px", overflow: "hidden", height: "3rem", fontSize: "12px", textAlign: "center", }}>

                                                <th></th>
                                                <th style={{ width: "9%" }}>Project Name</th>
                                                <th style={{ width: "9%" }}>Demand Number</th>
                                                <th style={{ width: "9%" }}>Budget Head Code</th>
                                                <th style={{ width: "8%" }}>Bill Type</th>
                                                <th style={{ width: "8%" }}>Bill Date</th>
                                                <th style={{ width: "8%" }}>Bill Amount</th>
                                                <th style={{ width: "9%" }}>Deduction</th>
                                                <th style={{ width: "9%" }}>Contractor Name</th>
                                                <th style={{ width: "10%" }}>Bill Copy</th>
                                                <th style={{ width: "13%" }}>Work Order Copy</th>
                                                {/* <th>General Manager Approval</th>
                            <th>Account Approval</th>
                            <th>Admin Approval</th> */}
                                            </tr>
                                        )}
                                    </thead>
                                    <tbody>
                                        {currentBills.length < 1 ? <tr><td style={{ background: 'linear-gradient(to bottom, #CCEAF7, #CFE4F1, #CCE1EE, #D8D9EC)', color: "black", height: '2.5rem', border: 'none', display: 'grid', justifyContent: 'center', alignItems: 'center' }}>No Bills For Approvals</td></tr> : currentBills.map((bill, index) => (

                                            <tr style={{ height: '5rem' }} key={bill.UniqueID}>
                                                <td style={{ height: '2.5rem' }}>
                                                    <input
                                                        type="checkbox"
                                                        style={{ marginRight: '5px', height: '1.5rem', width: '1.5rem' }}
                                                        checked={selectedBills.includes(bill.DemandGenerationID)}
                                                        onChange={() => handleCheckboxChange(bill.DemandGenerationID)}
                                                    />
                                                </td>
                                                {/* <td>{indexOfFirstBill + index + 1}</td> */}
                                                <td >{bill.ProjectName}</td>
                                                <td >{bill.DemandGenerationID}</td>
                                                <td >{bill.BudgetID}</td>
                                                <td>--</td>
                                                <td >{new Date(bill.Date).toLocaleString()}</td>
                                                <td >{bill.NetPayableAmount}</td>
                                                <td >{bill.DeductionAmount}</td>
                                                <td >{bill.ContractorName}</td>
                                                <td ><p><a href={`${apiurl}/BillCopyDocsImages/${bill.UploadBillCopy}`} target='_blank'>{bill.UploadBillCopy}</a></p></td>
                                                <td ><p><a href={`${apiurl}/WorkOrderDocsImages/${bill.CopyofWorkOrder}`} target='_blank'>{bill.CopyofWorkOrder}</a></p></td>
                                                {/* <td>{bill.General_Manager_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                <td>{bill.Account_Approval === 'true' ? 'Approved' : 'Not Approved'}</td>
                                <td>{bill.Admin_Approval === 'true' ? 'Approved' : 'Not Approved'}</td> */}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Pagination Controls */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div>
                                <button
                                    onClick={approveSelected} disabled={loading}
                                    style={{ display: 'flex', alignItems: 'center', gap: '8px', margin: '12px', padding: '8px 15px', background: 'linear-gradient(to Right, #3b409e , #0067ab , #0f79ba , #0098d5 )', color: 'white', borderRadius: '5px', cursor: loading ? 'not-allowed' : 'pointer' }}
                                ><img src={True32} style={{ width: '14px', filter: 'brightness(0) invert(1)' }} /> {loading ? 'Processing...' : 'Approve Selected'}
                                </button>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', margin: '10px 0' }}>
                                <button
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                    style={{ padding: '8px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === 1 ? '#ccc' : 'blue', color: 'white' }}
                                >
                                    Previous
                                </button>
                                <span style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                    Page {currentPage} of {totalPages}
                                </span>
                                <button
                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                                    disabled={currentPage === totalPages}
                                    style={{ padding: '6px 15px', borderRadius: '5px', cursor: 'pointer', backgroundColor: currentPage === totalPages ? '#ccc' : 'blue', color: 'white' }}
                                >
                                    Next
                                </button>
                            </div>


                        </div>
                    </>
                }
            </div>
        </div>
    );
};

export default BillApprovals;